import { render, staticRenderFns } from "./smallCouponItem.vue?vue&type=template&id=1d976d11&scoped=true&"
import script from "./smallCouponItem.vue?vue&type=script&lang=ts&"
export * from "./smallCouponItem.vue?vue&type=script&lang=ts&"
import style0 from "./smallCouponItem.vue?vue&type=style&index=0&id=1d976d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d976d11",
  null
  
)

export default component.exports